import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationListResponseData,
  ILabReportInterpretationPetListPayload,
  ILabReportInterpretationPetListResponse,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationPetListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [data, setData] = useState<ILabReportInterpretationListResponseData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const execute = useCallback(async (payload: ILabReportInterpretationPetListPayload) => {
    setLoading(true);
    setError(false);
    const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
    await axios
      .post(LAB_REPORT.LAB_REPORT_INTERPRETATION_PET_LIST.baseURL, payload, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res: AxiosResponse<ILabReportInterpretationPetListResponse>) => {
        setData(res.data?.data?.items ?? []);
        if (res.data?.status === false) setError(true);
      })
      .catch((e: AxiosError) => {
        sendCurl(e.config?.["curlCommand"]);
        captureError(e);
        setData([]);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  return { execute, data, loading, error };
};
